import { useRouter } from 'next/router'

export const useTranslations = () => {
  const router = useRouter()
  const { locale } = router
  const t = require(`../../translation/${locale.split('-')[0]}.json`)
 
  return {
    t: (key) => {
      const keys = key.split('.')
      return keys.reduce((obj, key) => obj?.[key], t) || key
    },
    locale
  }
}